// ── ONBOARDING STATE HELPERS (fp-nofodesk-9 follow-up) — extracted from App.js ──
import { API, apiFetch } from "./api";

const onbKey = (uid) => `nofodesk_onb_${uid}`;

function loadOnboarding(uid) {
  try { return JSON.parse(localStorage.getItem(onbKey(uid)) || "null"); }
  catch { return null; }
}

function logOnboardingEvent(event) {
  apiFetch(`${API}/onboarding/event`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ event }),
  }).catch(() => {});
}

export { onbKey, loadOnboarding, logOnboardingEvent };
